import { apiService } from "@/services";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleApiError } from "@/utils";
import queryClient from "@/query-client";
import { AssignBrandUsersParams, Brand, CreateBrandParams, UpdateBrandParams } from "@/types";
import { DEFAULT_STALE_TIME } from "@/constants";

export const useGetBrands = (options?: object) =>
  useQuery<Brand[]>({
    queryKey: ["brands"],
    queryFn: () => apiService.get("/brands"),
    staleTime: DEFAULT_STALE_TIME,
    ...options,
  });

export const useCreateBrand = () =>
  useMutation<Brand, unknown, CreateBrandParams>({
    mutationFn: (data) => apiService.post("/brands", data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["brands"] }),
    onError: (error) => handleApiError(error),
  });

export const useUpdateBrand = () =>
  useMutation<Brand, unknown, UpdateBrandParams>({
    mutationFn: ({ brandId, ...data }) => apiService.put(`/brands/${brandId}`, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["brands"] }),
    onError: (error) => handleApiError(error),
  });

export const useDeleteBrand = () =>
  useMutation<unknown, unknown, number>({
    mutationFn: (brandId) => apiService.delete(`/brands/${brandId}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["brands"] }),
    onError: (error) => handleApiError(error),
  });

export const useAssignBrandUsers = () =>
  useMutation<Brand, unknown, AssignBrandUsersParams>({
    mutationFn: ({ brandId, user_ids }) =>
      apiService.patch(`/brands/${brandId}/assign-users`, { user_ids }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["brands"] }),
    onError: (error) => handleApiError(error),
  });
